import getDisplayInformation from './get-display-information';
import InsuranceProviderLogo from './insurance-provider-logo';
import { MarketplaceLogo } from '../logo-components/marketplace-logo';
import { ProviderLogo } from '../logo-components/provider-logo';

/**
 * @typedef {'icon'|'logo'|'alternateIcon'} LogoType
 */

/**
 * @param {object} props
 * @param {string|number} [props.providerId]
 * @param {string|number} [props.carrierId]
 * @param {string|number} [props.marketplaceId]
 * @param {string|number} [props.fillProviderId]
 * @param {string|number} [props.insuranceProviderId]
 * @param {LogoType} [props.logoType] - Used by internal MarketplaceLogo and ProviderLogo
 * @param {boolean} [props.showIcon] - Used by internal InsuranceProviderLogo
 * @returns {React.JSX.Element}
 */
const DataDrivenLogo = ({
  providerId,
  carrierId,
  marketplaceId,
  fillProviderId,
  insuranceProviderId,
  logoType = 'logo',
  showIcon = false,
  ...rest
}) => {
  const displayInformation = getDisplayInformation({
    providerId,
    carrierId,
    marketplaceId,
    fillProviderId,
    insuranceProviderId,
  });

  if (marketplaceId !== undefined) {
    return <MarketplaceLogo displayInformation={displayInformation} type={logoType} {...rest} />;
  }

  if (insuranceProviderId !== undefined) {
    return <InsuranceProviderLogo displayInformation={displayInformation} showIcon={showIcon} {...rest} />;
  }

  return <ProviderLogo displayInformation={displayInformation} type={logoType} {...rest} />;
};

export default DataDrivenLogo;
